export const getActiveSegment = (value, segments) => {
    const rawSegments = (value / 100) * segments;
    if (value < 10) {
        return Math.ceil(rawSegments);
    }
    if (value > 90) {
        return Math.floor(rawSegments);
    }
    return Math.round(rawSegments);
};
